import type { PageConfig } from "../types";

export const page: PageConfig = {
  title: "MP Graphs",
  description:
    "Plot vibration and temperature readings for a monitoring point.",
  icon: "chart-line",
  order: 10,
};
